import React from "react";
import "./index.scss"

export const NotFound = React.memo(()=>{
    return <div className={"not_found"}>
        <h1>404</h1>
        <p>Not Found</p>
    </div>
})